/* eslint-disable prefer-destructuring */
import shippingLabelConstants from '@/store/modules/shippingLabelPage/constants';

export default {
  [shippingLabelConstants.getterTypes.shippingInfo]: (state, getters, rootState) => (includeBoxes) => {
    const shipFrom = state.shipFrom;
    const shipTo = state.shipTo;
    const poNumber = rootState.poDetails.poNumber;
    const currentGroupLineItemNumber = rootState.poDetails.currentGroupLineItemNumber;

    let result = {
      from: {
        company: shipFrom.companyName,
        street: shipFrom.street,
        city: shipFrom.city,
        zip: shipFrom.zipCode,
        state: shipFrom.state,
      },
      to: {
        company: shipTo.companyName,
        street: shipTo.street,
        city: shipTo.city,
        zip: shipTo.zipCode,
        state: shipTo.state,
      },
      poNumber,
    };

    if (includeBoxes) {
      const currentLineItem = rootState.poDetails.groupedLineItems
        .find(li => li.itemNumber === currentGroupLineItemNumber);

      const skus = [];
      currentLineItem.lineItems.filter(li => li.qty > 0).forEach((element) => {
        if (element.finishedGoodsSkuInfo != null && element.finishedGoodsSkuInfo.length > 0) {
          const skuInfo = element.finishedGoodsSkuInfo.map(item => ({
            sku: item.sku,
            description: item.description,
          }));

          skus.push({
            skuInfo,
            boxes: element.boxes,
          });
        } else {
          skus.push({
            skuInfo: [{
              sku: element.sku,
              description: element.description,
            }],
            boxes: element.boxes,
          });
        }
      });

      result = {
        ...result,
        skus,
      };
    }

    return result;
  },
};
